import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { queryClient } from '@/lib/queryClient';
import { getOperationPackages } from './-query';
import { operationPackageQueryKeys } from './-query/keys';
import { SearchSchema } from './-zod-schemas';
export const Route = createFileRoute('/_staff/ga-operation-core/_packages/')({
  validateSearch: zodValidator(SearchSchema),
  loader: async () => {
    const operationPackages = await queryClient.fetchQuery({
      queryKey: operationPackageQueryKeys.list(),
      queryFn: () => getOperationPackages()
    });
    return {
      operationPackages
    };
  }
});